import { g as getElementFromRef } from '../LocalModules/storm-ui-utils/dist/esm/getElementFromRef-DUWqD2Fg-DUWqD2Fg.js';
import { t as trapTabFocus } from '../LocalModules/storm-ui-utils/dist/esm/focusableElements/trapTabFocus-CDT7jWDj-DPG2qBEI.js';
import { K as KEYBOARD_KEYNAMES } from '../LocalModules/storm-ui-utils/dist/esm/keyboardKeynames-CVa_vjg3-CVa_vjg3.js';

function useModal(params) {
  const {
    initialRef,
    onClose,
    triggerRef,
    firstRef
  } = params;
  const handleKeyUp = event => {
    if (event.key === KEYBOARD_KEYNAMES.ESCAPE) {
      event.preventDefault();
      event.stopPropagation();
      if (onClose) {
        onClose(event);
      }
    }
  };
  const handleKeyDown = event => {
    if (initialRef.current) {
      trapTabFocus(event, initialRef.current);
    }
  };
  const handleFocusOnExit = () => {
    if (triggerRef) {
      const element = getElementFromRef(triggerRef);
      if (element !== null && element !== void 0 && element.focus) {
        element.focus();
      }
    }
  };
  const handleFocusOnEnter = () => {
    if (firstRef) {
      const element = getElementFromRef(firstRef);
      if (element !== null && element !== void 0 && element.focus) {
        element.focus();
      }
    }
  };
  return {
    handleKeyUp,
    handleKeyDown,
    handleFocusOnExit,
    handleFocusOnEnter
  };
}

export { useModal as u };
//# sourceMappingURL=useModalBehaviors-CGKUe7-Y.js.map
